<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <div class="w-full border-b py-4 leading-none">
      <div class="flex items-center justify-between">
        <div class="brand-heading text-base text-gray-600">
          Distance
        </div>
        <div class="brand-body text-base text-gray-500">
          {{ filters.distance }}mi<span v-if="filters.distance === 100">+</span>
        </div>
      </div>

      <div class="mx-1 mt-3">
        <VueSlider
          v-model="filters.distance"
          :tooltip="'none'"
        />
      </div>
    </div>
    <div class="w-full border-b py-4 leading-none">
      <div class="flex items-center justify-between">
        <div class="brand-heading text-base text-gray-600">
          Average Price
        </div>
        <div class="brand-body text-base text-gray-500">
          {{ filters.maxAveragePrice }}<span v-if="filters.maxAveragePrice === 10">+</span> Points
        </div>
      </div>

      <div class="mx-1 mt-3">
        <VueSlider
          v-model="filters.maxAveragePrice"
          :min="0"
          :max="10"
          :tooltip="'none'"
        />
      </div>
    </div>
    <div class="w-full border-b py-4 leading-none">
      <div class="flex items-center justify-between">
        <div class="brand-heading text-base text-gray-600">
          Price Range
        </div>
        <div class="brand-body text-base text-gray-500">
          {{ filters.minMaxRange[0] }}-{{ filters.minMaxRange[1]
          }}<span v-if="filters.minMaxRange[1] === 15">+</span> Points
        </div>
      </div>

      <div class="mx-1 mt-3">
        <VueSlider
          v-model="filters.minMaxRange"
          :min="0"
          :max="15"
          :tooltip="'none'"
        />
      </div>
    </div>

    <div class="w-full border-b py-4 pb-1 leading-none">
      <div class="flex items-center justify-between">
        <div class="brand-heading text-base text-gray-600">
          Facilities
        </div>
      </div>

      <div class="mt-4 select-none">
        <div
          v-for="(facility, index) in filters.facilities"
          :key="'facility' + index"
        >
          <div class="mb-4 flex items-center justify-between md:mb-3">
            <div class="brand-body text-sm text-gray-500">
              {{ facility.name }}
            </div>

            <div class="block md:hidden">
              <toggle-button
                :value="facility.enabled"
                color="#ADD24E"
                :sync="true"
                :width="40"
                :height="20"
                @change="toggleFacility(index)"
              />
            </div>
            <div class="hidden md:block">
              <toggle-button
                :value="facility.enabled"
                color="#ADD24E"
                :sync="true"
                :width="34"
                :height="18"
                @change="toggleFacility(index)"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import { ToggleButton } from 'vue-js-toggle-button';

export default {
  components: {
    VueSlider,
    ToggleButton,
  },

  props: {
    filters: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {};
  },

  methods: {
    toggleFacility(index) {
      this.$emit('toggleFacility', index);
    },
  },
};
</script>

<style lang="scss">
.playmoregolf {
  --slider-color: #add24e;
}

.nine {
  --slider-color: #d4ba82;
}

/* Set the theme color of the component */
$themeColor: var(--slider-color);

/* import theme style */
@import 'vue-slider-component/lib/theme/default.scss';
</style>
